<template>
	<div class="first">
		<dingbu></dingbu>
		<div class="home_content">
			<div class="bg_color" :style="{
          background:
            'url(' +
            require('../../assets/img/' + bei_ing) +
            ') no-repeat center center',
          'background-size': '100% 100%',
        }">
				<div class="w">
					<div class="center__one">
						<div class="lft__img_s">
							<div class="img__bitlt">
								<el-carousel :interval="interval" :loop="true" arrow="always">
									<el-carousel-item v-for="(item, index) in swipe" :key="index">
										<div class="loops">
											<a :href="item.url" target="_blank">
												<img :src="item.image" alt class="lunbo-box" />
											</a>
											<div class="post__tion" v-if="item.title != ''">
												<div class="post__small">
													<div class="small_txts">
														{{ item.title }}
													</div>
												</div>
											</div>
										</div>
									</el-carousel-item>
								</el-carousel>
							</div>
							<div class="notice__box_">
								<div class="notice__title_lsit">
									<div class="notice__title_name" :style="{
                      background:
                        'url(' +
                        require('../../assets/img/img_58.png') +
                        ') no-repeat center center',
                      'background-size': '100% 100%',
                    }">
										通知公告
									</div>
									<div class="looked__more" @click="lookedNotice(1)">
										<div class="more__name">更多</div>
										<img src="../../assets/img/img_33.png" alt="" />
									</div>
								</div>

								<div class="notice__Lists">
									<div class="lists_nit">
										<div class="nit__item" v-for="(item, index) in noticeList" :key="index"
											@click="noticeItem(item.id)">
											<div class="left__item">
												<img src="../../assets/img/img_09.png" alt="" />
												<div class="text__item title_one">
													{{ item.title }}
												</div>
											</div>
											<div class="date__">{{ item.createtime }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="rig__img_d">
							<div class="rih__img_itme" v-for="(item, index) in rukou" :key="index"
								@click="nextLogin(item.type_id, item, index)" v-if="item.id <= 3">
								<img :src="item.image" class="bg_image" alt="" />

								<div class="rukou__item">
									<div class="ru__box">
										<div class="ru_one">
											{{ item.title }}
										</div>
										<div class="ru__two">
											{{ item.name2 }}
										</div>
										<div class="ru__three">
											<div class="thr_item">
												{{ item.name3 }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="center__two">
						<div class="center_child_box">
							<div class="center__child">
								<div class="left__child">
									<div class="down__left">
										<div class="chile__top_one" @click="lookedNotice(2)">
											<div class="top_one_name">政策动态</div>
											<div class="top__moes">
												<div class="moes_name">更多</div>
											</div>
										</div>
										<div class="chile_img">
											<img :src="policyImage" alt="" />
										</div>
									</div>
									<div class="down__right_list">
										<div class="ri__list" v-for="(item, index) in policyList" :key="index"
											@click="onCkpolicy(item.id)">
											<div class="bg__dian"></div>
											<div class="ri_items title_one">
												{{ item.title }}
											</div>
										</div>
									</div>
								</div>
								<div class="center__chld_item">
									<div class="down__left">
										<div class="chile__top_one" @click="lookedNotice(5)">
											<div class="top_one_name">下载专区</div>
											<div class="top__moes">
												<div class="moes_name">更多</div>
											</div>
										</div>
										<div class="chile_img">
											<img :src="policydownload" alt="" />
										</div>
									</div>
									<div class="down__right_list">
										<div class="ri__list" @click="onCkLoad(item.id)"
											v-for="(item, index) in downloadList" :key="index">
											<div class="bg__dian"></div>
											<div class="ri_items title_one">
												{{ item.title }}
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="riht__child">
							<!-- 	<div class="app__download" @click="clickParent">
									<div class="left__xs">
										<img src="../../assets/img/img_01.png" class="icon_app" alt="" />
										<div class="left_xs_name">
											<div class="big_name">APP下载</div>
											<div class="small__name">金建APP下载</div>
										</div>
									</div>
									<div class="img__arrow">
										<img src="../../assets/img/img_10.png" alt="" />
									</div>
								</div> -->
								<div class="call__me call__me__study" v-for="(item, index) in rukou" :key="index"
								@click="nextLogin(item.type_id, item, index)" v-if="item.id > 3">
									<div class="big__title">
										<div class="title_bigname">{{ item.title }}</div>
										<img src="../../assets/img/img_03.png" alt="" />
									</div>
									<div class="phone__ist" style="margin-top: 15px;">
										<span>15332091563</span>
										<span>18522107922</span>
									</div>
								</div>
								<div class="app__download" @click="youChangedKe">
									<div class="left__xs">
										<img src="../../assets/img/img_05.png" class="icon_app" alt="" />
										<div class="left_xs_name">
											<div class="big_name">优选课程</div>
											<div class="small__name">{{ rukouClass.title }}</div>
										</div>
									</div>
									<div class="img__arrow">
										<img src="../../assets/img/img_10.png" alt="" />
									</div>
								</div>
								<div class="call__me" @click="callMy">
									<div class="big__title">
										<div class="title_bigname">安管人员继续教育联系客服</div>
										<img src="../../assets/img/img_03.png" alt="" />
									</div>
									<div class="phone__ist">
										<span>{{ rukouAbout.phone1 }}</span>
										<span>{{ rukouAbout.phone2 }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<dibu></dibu>
		<daohan ref="mychild"></daohan>
		<el-dialog
				:close-on-click-modal="false"
				:title="pupInfo.title"
				:visible.sync="pupInfo.is_show"
				width="30%"
				center
				>
			<div  class="dialog-footer" v-html="pupInfo.content"></div>
		</el-dialog>
	</div>
</template>

<script>
	import daohan from "../daohan";
	import dibu from "../dibu";
	import dingbu from "../dingbu";
	// import { mapState, mapMutations, mapActions } from "vuex"

	export default {

		name: "carrousel",
		components: {
			daohan,
			dibu,
			dingbu
		},
		data() {
			return {
				pupInfo:'',
				dialogVisible: true,
				interval: 5000,
				swipe: [],
				referral: [],
				show: false,
				addlist: [],
				num: 0,
				timmeOue: 0,


				// -------------------------
				bei_ing: this.Public.bei_ing,
				headIndex: 0,
				noticeList: [],
				policyList: [],
				downloadList: [],
				rukouAbout: {},
				rukouClass: {},
				policydownload: '',
				policyImage: '',
				rukou: [],
				callList: [],
				loop: [],
			};
		},
		computed: {},
		created() {
			this.add();
			let token = localStorage.getItem('token-qzb')
			// this.token = token
			this.getbanner();
			this.getNoticeList();
			this.getPolicyList();
			this.getDownloadList();
			this.getPolicyDown();
			this.getRukou();
			this.initPupInfo()
			console.log(1123111);

		},
		mounted() {


		},
		methods: {
			initPupInfo() {
				let that = this,
						url = "common/notice",
						param = {};
				this.post(url, param)
						.then((res) => {
							console.log('>>>>>>>>>>>>>>>>>>',res)
							this.pupInfo = res.data
						})
						.catch((err) => { 
							console.log(err);
						});
			},
			nextLogin(id, item, index) {
				console.log(id,item); 
				let token = localStorage.getItem('token-qzb')	
				if (token) { 
					if (item.is_enter != 0) {
						let obj = {
							id: id,
							is_true: false
						}
						this.$router.push({
							path: '/learn',
							query: {
								info: JSON.stringify(obj)
							}
						})
						sessionStorage.setItem("orderindex", 4);
					} else {
						this.$message.warning('暂未开通')
					}
					// if (index != 0) {

					// } else {
					//   window.open('http://jjjywx.hnzye.cn/dist/index.html#/index')
					// }
				} else {
					this.$router.push('/login')
				}     


			},
			lookedNotice(num) { // 更多 通告
				let itd = Number(num)
				switch (itd) {
					case 1:
						this.$router.push('/inform')
						sessionStorage.setItem("orderindex", itd);
						break;
					case 2:
						this.$router.push('/policy')
						sessionStorage.setItem("orderindex", itd);
						break;
					case 5:
						this.$router.push('/downloadSection')
						sessionStorage.setItem("orderindex", itd);
						break;
					default:
						break;
				}
			},
			noticeItem(id) { // 通告详情
				this.$router.push({
					path: '/information',
					query: {
						id: id
					}
				})
				sessionStorage.setItem("orderindex", 1);
			},
			onCkpolicy(id) { // 动态详情
				this.$router.push({
					path: '/policyation',
					query: {
						id: id
					}
				})
				sessionStorage.setItem("orderindex", 2);
			},
			onCkLoad(id) { // 下载专区详情
				this.$router.push({
					path: '/downloadDetail',
					query: {
						id: id
					}
				})
				sessionStorage.setItem("orderindex", 5);
			},
			clickParent() { // 打开app 弹窗
				this.$refs.mychild.parentHandleclick("嘿嘿嘿");
			},
			youChangedKe() { // 去优选课程
				this.$router.push('/curriculum')
				sessionStorage.setItem("orderindex", 3);

			},
			callMy() { // 联系我们
				this.$router.push('/contactUs')
				sessionStorage.setItem("orderindex", 7);

			},
			getbanner() { //轮播图片接口
				let that = this,
					url = "index/banner",
					param = {};
				this.post(url)
					.then(res => {
						this.swipe = res.data;
						console.log(res.data, '轮播图片接口');
					})
					.catch(err => {
						console.log(err);
					});
			},
			async getNoticeList() { // 获取通告列表
				let that = this,
					url = "index/information",
					param = {};
				try {
					const {
						data
					} = await this.post(url)
					console.log(data, "获取通告列表");
					this.noticeList = data
				} catch (err) {
					console.log(err);
				}
			},
			async getPolicyList() { // 获取政策动态
				let that = this,
					url = "index/policy",
					param = {};
				try {
					const {
						data
					} = await this.post(url)
					console.log(data, "获取政策动态");
					this.policyList = data
				} catch (err) {
					console.log(err);
				}
			},
			async getDownloadList() { // 获取下载专区
				let that = this,
					url = "index/download",
					param = {};
				try {
					const {
						data
					} = await this.post(url)
					console.log(data, "下载专区");
					this.downloadList = data
				} catch (err) {
					console.log(err);
				}
			},
			async getPolicyDown() { // 获取政策动态和下载专区图片
				let that = this,
					url = "index/image_policy",
					param = {};
				try {
					const {
						data
					} = await this.post(url)
					console.log(data, "获取政策动态和下载专区图片");
					this.policydownload = data.download
					this.policyImage = data.policy
				} catch (err) {
					console.log(err);
				}
			},
			async getRukou() { // 获取模块入口
				let that = this,
					url = "index/enter",
					param = {};
				try {
					const {
						data
					} = await this.post(url)
					console.log(data, "模块入口");
					if (data.study.length != 0) {
						data.study.forEach(item => {
							item.name2 = '学习平台'
							item.name3 = '学习入口'
						});
					}
					this.rukou = data.study

					this.rukouClass = data.class
					this.rukouAbout = data.about
				} catch (err) {
					console.log(err);
				}
			},
			mouseOver() {
				if (this.timmeOue == 1) {
					this.timmeOue = 0;
					this.add()
				} else {
					console.log("我直接走")
				}

			},

			add() {
				var that = this;

				function addservfer() {
					if (that.timmeOue == 1) {
						clearInterval(interval);
					} else {
						var number = that.num - 289;
						var add = -that.addlist.length * 289 + 4 * 289;
						if (add >= number) {
							that.num = 0;
						} else {
							that.num = number;
						}
					}
				}
				var interval = window.setInterval(addservfer, 2000);
			},

		}
	};
</script>
<style scoped lang="less">
	@import "../../css/first.css";

	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 300px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n + 1) {
		background-color: #d3dce6;
	}

	.lunbo-box {
		width: 100%;
		height: 100%;
	}

	//   第三部分
	.home_content {
		width: 100%;
		padding-bottom: 300px;
		box-sizing: border-box;

		.bg_color {
			width: 100%;
			height: 448px;
			padding-top: 16px;
			box-sizing: border-box;

			.center__one {
				width: 100%;
				padding: 21px;
				box-sizing: border-box;
				background-color: #fff;
				display: flex;

				.lft__img_s {
					width: 100%;
					display: flex;

					.img__bitlt {
						width: 400px;
						height: 310px;

						.loops {
							width: 100%;
							height: 310px;
							position: relative;

							img {
								width: 100%;
							}

							.post__tion {
								position: absolute;
								bottom: 0;
								left: 0;
								z-index: 2;
								width: 100%;

								.post__small {
									width: 100%;
									padding: 13px;
									box-sizing: border-box;
									opacity: 0.75;
									background: rgba(45, 82, 177, 0.75);

									.small_txts {
										font-size: 16px;
										font-family: Source Han Sans CN, Source Han Sans CN-Medium;
										font-weight: 500;
										text-align: left;
										color: #ffffff;
										line-height: 22px;
									}
								}
							}
						}

						img {
							width: 100%;
						}
					}

					.notice__box_ {
						flex: 1;
						padding: 0 20px;
						box-sizing: border-box;

						.notice__title_lsit {
							width: 100%;
							display: flex;
							align-items: center;
							justify-content: space-between;
							height: 43px;
							padding-bottom: 5px;
							box-sizing: border-box;
							border-bottom: 1px solid #b0b7c3;

							.notice__title_name {
								width: 122px;
								height: 38px;
								// background: #2d52b1;
								padding-right: 22px;
								box-sizing: border-box;
								display: flex;
								align-items: center;
								justify-content: center;
								font-size: 18px;
								font-family: Source Han Sans CN, Source Han Sans CN-Medium;
								font-weight: 500;
								color: #ffffff;
								position: relative;

								&::after {
									content: "";
									position: absolute;
									bottom: -5px;
									left: 0;
									width: 234px;
									height: 2px;
									background: #d6a07a;
								}
							}

							.looked__more {
								display: flex;
								align-items: center;
								justify-content: flex-end;

								.more__name {
									font-size: 14px;
									font-family: Source Han Sans CN, Source Han Sans CN-Regular;
									font-weight: 400;
									text-align: right;
									color: #5b5e63;
									line-height: 24px;
								}

								img {
									width: 7px;
									height: 12px;
									margin-left: 5px;
								}
							}
						}

						.notice__Lists {
							width: 100%;
							padding-top: 6px;
							box-sizing: border-box;

							.lists_nit {
								width: 100%;

								.nit__item {
									width: 100%;
									display: flex;
									align-items: center;
									justify-content: space-between;
									padding: 4px 0;
									box-sizing: border-box;

									.left__item {
										flex: 1;
										display: flex;
										align-items: center;
										padding-right: 20px;
										box-sizing: border-box;

										img {
											width: 10px;
											height: 10px;
											flex-shrink: 0;
											margin-right: 5px;
										}

										.text__item {
											flex: 1;
											font-size: 14px;
											font-family: Source Han Sans CN, Source Han Sans CN-Regular;
											font-weight: 400;
											text-align: left;
											color: #06121e;
											line-height: 20px;

											&:hover {
												color: #2d52b1;
											}
										}
									}

									.date__ {
										font-size: 14px;
										font-family: Source Han Sans CN, Source Han Sans CN-Regular;
										font-weight: 400;
										text-align: right;
										color: #06121e;
										line-height: 20px;
									}

									&:last-child {
										padding-bottom: 10px;
									}
								}
							}
						}
					}
				}

				.rig__img_d {
					width: 256px;

					.rih__img_itme {
						width: 256px;
						height: 101px;
						position: relative;
						margin-bottom: 5px;

						.bg_image {
							width: 100%;
						}

						.rukou__item {
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
							z-index: 2;
							width: 100%;

							.ru__box {
								display: flex;
								flex-direction: column;
								justify-content: space-around;
								align-items: center;

								.ru_one {
									width: 100%;
									font-size: 16px;
									font-family: Source Han Sans CN, Source Han Sans CN-Regular;
									font-weight: 400;
									text-align: center;
									color: #ffffff;
									line-height: 24px;
								}

								.ru__two {
									font-size: 20px;
									font-family: Source Han Sans CN, Source Han Sans CN-Medium;
									font-weight: 500;
									text-align: center;
									color: #ffffff;
									line-height: 24px;
									padding: 3px 0 6px;
									box-sizing: border-box;
								}

								.ru__three {
									width: 100%;
									display: flex;
									align-items: center;
									justify-content: center;

									.thr_item {
										width: 132px;
										height: 28px;
										background: transparent;
										border-radius: 14px;
										border: 1px solid rgba(255, 255, 255, 0.3);
										box-sizing: border-box;
										font-size: 14px;
										font-family: Source Han Sans CN, Source Han Sans CN-Medium;
										font-weight: 500;
										text-align: left;
										color: #ffffff;
										line-height: 24px;
										display: flex;
										align-items: center;
										justify-content: center;
									}

									.ru_color1 {
										background: #4d73b9;
									}

									.ru_color2 {
										background: #544cb5;
									}

									.ru_color3 {
										background: #d3a280;
									}
								}
							}
						}

						&:last-child {
							margin-bottom: 0;
						}
					}
				}
			}

			.center__two {
				width: 100%;
				margin-top: 16px;

				.center_child_box {
					width: 100%;
					padding: 21px;
					box-sizing: border-box;
					background-color: #fff;
					display: flex;

					.center__child {
						width: 100%;
						display: flex;

						.left__child,
						.center__chld_item {
							display: flex;

							.down__left {
								width: 118px;

								.chile__top_one {
									width: 118px;
									height: 70px;
									background: #2d52b1;
									display: flex;
									align-items: center;
									justify-content: center;
									flex-direction: column;

									.top_one_name {
										font-size: 18px;
										font-family: Source Han Sans CN, Source Han Sans CN-Medium;
										font-weight: 500;
										text-align: center;
										color: #ffffff;
										line-height: 24px;
									}

									.top__moes {
										width: 100%;
										display: flex;
										align-items: center;
										justify-content: center;
										padding-top: 8px;
										box-sizing: border-box;

										.moes_name {
											width: 44px;
											height: 15px;
											background: #d6a07a;
											border-radius: 8px;
											display: flex;
											align-items: center;
											justify-content: center;
											font-size: 10px;
											font-family: Source Han Sans CN, Source Han Sans CN-Regular;
											font-weight: 400;
											color: #ffffff;
										}
									}
								}

								.chile_img {
									width: 118px;
									margin-top: 3px;

									img {
										width: 118px;
										height: 213px;
									}
								}
							}

							.down__right_list {
								width: 330;
								padding: 0 40px 0 20px;
								box-sizing: border-box;

								.ri__list {
									width: 100%;
									display: flex;
									align-items: center;

									.bg__dian {
										width: 6px;
										height: 6px;
										background: #d6a07a;
										border-radius: 50%;
									}

									.ri_items {
										width: 252px;
										margin-left: 12px;
										box-sizing: border-box;
										font-size: 14px;
										font-family: Source Han Sans CN, Source Han Sans CN-Regular;
										font-weight: 400;
										text-align: left;
										color: #06121e;
										line-height: 24px;

										&:hover {
											color: #2d52b1;
										}
									}
								}
							}
						}
					}

					.riht__child {
						width: 256px;

						.app__download {
							width: 256px;
							height: 90px;
							background: #2d52b1;
							border-radius: 4px;
							padding: 15px 11px;
							box-sizing: border-box;
							display: flex;
							align-items: center;
							margin-bottom: 8px;

							.left__xs {
								flex: 1;
								display: flex;
								align-items: center;
								height: 60px;

								.icon_app {
									width: 60px;
									height: 60px;
									margin-right: 7px;
								}

								.left_xs_name {
									.big_name {
										font-size: 20px;
										font-family: Source Han Sans CN, Source Han Sans CN-Medium;
										font-weight: 500;
										text-align: left;
										color: #ffffff;
										line-height: 24px;
									}

									.small__name {
										font-size: 14px;
										font-family: Source Han Sans CN, Source Han Sans CN-Regular;
										font-weight: 400;
										text-align: left;
										color: #ffffff;
										line-height: 24px;
										opacity: 0.8;
									}
								}
							}

							.img__arrow {
								width: 21px;
								height: 60px;
								display: flex;
								align-items: center;
								justify-content: flex-start;

								img {
									width: 16px;
									height: 16px;
								}
							}
						}

						.call__me {
							width: 256px;
							height: 90px;
							background: #b7815a;
							border-radius: 4px;
							padding: 15px 16px 15px 11px;
							box-sizing: border-box;

							.big__title {
								width: 100%;
								display: flex;
								align-items: center;
								justify-content: space-between;

								.title_bigname {
									font-size: 18px;
									font-family: Source Han Sans CN, Source Han Sans CN-Medium;
									font-weight: 500;
									text-align: left;
									color: #ffffff;
									line-height: 24px;
								}

								img {
									width: 20px;
									height: 20px;
								}
							}

							.phone__ist {
								display: flex;
								align-items: center;
								justify-content: space-between;
								width: 100%;
								// margin-top: 14px;

								span {
									font-size: 14px;
									font-family: Source Han Sans CN, Source Han Sans CN-Regular;
									font-weight: 400;
									color: #ffffff;
									line-height: 24px;
									opacity: 0.8;
								}
							}
						}

						.call__me__study {
							margin-bottom: 8px;
							background-color: #1C4899;
						}
					}
				}
			}
		}
	}
</style>
<style>
	.el-carousel--horizontal {
		width: 100% !important;
		/* overflow-x: hidden; */
		height: 100% !important;
	}

	.el-carousel__container {
		position: relative;
		height: 100% !important;
	}

	.el-carousel__arrow {
		width: 50px !important;
		height: 50px !important;
	}

	.jianshi-mn {
		transition: all 1s ease;
	}
	/*.popBox{*/
	/*	width: 400px;*/
	/*	height: 500px;*/
	/*	background: #1F1F1F;*/
	/* }*/
	.dialog-footer{
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
	}
</style>
